import React from 'react';
import { problemData } from '@/data/mock';
import { FileWarning, Search, TrendingDown, ShieldOff } from 'lucide-react';

const iconMap = {
  FileWarning,
  Search,
  TrendingDown,
  ShieldOff,
};

export const ProblemSection = () => {
  return (
    <section id="product" className="relative py-24 bg-slate-950">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900/50 to-slate-950" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-rose-500/10 text-rose-400 text-sm font-medium rounded-full mb-4">
            The Problem
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {problemData.title}
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            The resume-based hiring system is failing both employers and candidates
          </p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {problemData.problems.map((problem, index) => {
            const Icon = iconMap[problem.icon];
            return (
              <div
                key={index}
                className="group p-6 bg-slate-900/50 border border-slate-800/50 rounded-xl hover:border-rose-500/30 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-rose-500/10 flex items-center justify-center mb-4 group-hover:bg-rose-500/20 transition-colors">
                  <Icon size={24} className="text-rose-400" />
                </div>
                <p className="text-white font-medium text-lg">{problem.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
